import { VirtualizedTableColumnType } from 'services/virtualizedTable/types';
import RenderField from 'forms/RenderField';
import RenderDropdown from 'forms/RenderDropdown';
import RenderDatePicker from 'forms/RenderDatePicker';
import { toNumberIfValueNotNaN } from 'forms/normalizers';

import { RenderCheckbox } from 'forms';
import {
    FIELD_TYPE_DROPDOWN,
    FIELD_TYPE_DROPDOWN_MULTIPLE,
    FIELD_TYPE_STRING,
    FIELD_TYPE_NUMBER,
    FIELD_TYPE_PASSWORD,
    FIELD_TYPE_DATE,
    FIELD_TYPE_CONFIRMATION_CHECKBOX
} from '../../constants';

const getColumnTypeFieldProps = (
    columnType: VirtualizedTableColumnType
): Record<string, any> => {
    if (columnType === FIELD_TYPE_DROPDOWN) {
        return {
            component: RenderDropdown as any,
            fluid: true,
            search: true,
            selection: true,
            selectOnBlur: false,
            closeOnChange: true,
            nullOnUnmount: false
        };
    }

    if (columnType === FIELD_TYPE_DROPDOWN_MULTIPLE) {
        return {
            component: RenderDropdown as any,
            fluid: true,
            search: true,
            selection: true,
            selectOnBlur: false,
            closeOnChange: true,
            multiple: true,
            nullOnUnmount: false
        };
    }

    if (columnType === FIELD_TYPE_DATE) {
        return {
            dateFormat: 'dd/MM/yyyy',
            component: RenderDatePicker as any
        };
    }

    if (columnType === FIELD_TYPE_STRING) {
        return {
            component: RenderField as any,
            nullOnUnmount: false
        };
    }

    if (columnType === FIELD_TYPE_NUMBER) {
        return {
            component: RenderField as any,
            format: toNumberIfValueNotNaN,
            formatOnBlur: true,
            nullOnUnmount: false
        };
    }

    if (columnType === FIELD_TYPE_PASSWORD) {
        return {
            component: RenderField as any,
            type: 'password',
            nullOnUnmount: false
        };
    }

    if (columnType === FIELD_TYPE_CONFIRMATION_CHECKBOX) {
        return {
            component: RenderCheckbox as any,
            nullOnUnmount: false
        };
    }

    return {};
};

export default getColumnTypeFieldProps;
